import {Controller} from "stimulus"
import $ from 'jquery';


export default class extends Controller {

    connect() {
        const message = this.element.dataset.message;
        const type = this.element.dataset.type || 'info';
        let element = $(`#${this.element.dataset.reset}`)
        toastr[type](message);

        if(element.length > 0){
            element.val(0).trigger('change')
        }

        this.element.remove();
    }
}